import {vm} from '@/main'
import {Dispatcher} from '@/APIDispatcher'
import auth from '@/auth'

export const DemandApi = {

  list() {
    return new Promise((resolve, reject) => {
      Dispatcher.post('bidders/list', {}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('List Failed', 'Partner list failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  endpoints(companyId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('/bidder/endpoints', {company_id: companyId}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.list)
        } else {
          vm.$notify.error('List Failed', 'Failed to list endpoints: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  endpoint(endpoint) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('/bidder/endpoint/set', {endpoint: endpoint}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.list)
        } else {
          vm.$notify.error('Save Failed', 'Failed to save endpoint: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  details(companyId) {
    let args = {}
    return new Promise((resolve, reject) => {
      if (auth.isAdmin()) {
        args.company_id = companyId;
      }

      Dispatcher.post('bidder/details', args).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.bidder)
        } else {
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  set(bidder) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('bidder/set', { bidder }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          vm.$notify.error('Update Failed', 'Bidder update failed: ' + s.errorCode)
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  scanQueueList(companyId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('scans/queued', {company_id: companyId, status: 'QUEUED'}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.queued)
        } else {
          reject(Error(s.errorCode))
        }
      })
    })
  },
  scanScanningList(companyId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('scans/queued', {company_id: companyId, status: 'SCANNING'}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.queued)
        } else {
          reject(Error(s.errorCode))
        }
      })
    })
  },
  scanCompletedList(start, end, companyId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('scans/completed', {
          start: start,
          end: end,
          company_id: companyId}
        ).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.scans)
        } else {
          reject(Error(s.errorCode))
        }
      })
    })
  },
  approvalsList() {
    return new Promise((resolve, reject) => {
      Dispatcher.post('approvals/list', {}).then((res) => {
        if(Dispatcher.success(res)) {
          resolve(res.list)
        } else {
          reject(Error(res.errorCode))
        }
      })
    })
  },
  approvalSet(name, quality, reason) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('approvals/rate', {
        name, quality, reason
      }).then((res) => {
        if(Dispatcher.success(res)) {
          resolve()
        } else {
          reject(Error(res.errorCode))
        }
      })
    })
  },
  dealSave(deal) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('deals/public/set', { deal }).then((res) => {
        if(Dispatcher.success(res)) {
          resolve(res.deal)
        } else {
          reject(Error(res.errorCode))
        }
      })
    })
  },
  dealGet(id) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('deals/public/get', { id }).then((res) => {
        if(Dispatcher.success(res)) {
          resolve(res.deal)
        } else {
          reject(Error(res.errorCode))
        }
      })
    })
  },
  dealDelete(id) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('deals/public/delete', { id }).then((res) => {
        if(Dispatcher.success(res)) {
          resolve(true)
        } else {
          reject(Error(res.errorCode))
        }
      })
    })
  },
  dealList(companyId, showPublic) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('deals/public/list', {
        company_id: companyId,
        show_public: showPublic
      }).then((res) => {
        if(Dispatcher.success(res)) {
          resolve(res.list)
        } else {
          reject(Error(res.errorCode))
        }
      })
    })
  },
  commerceCatsList() {
    return new Promise((resolve, reject) => {
      Dispatcher.post('commerce/categories/list', {
      }).then((res) => {
        if(Dispatcher.success(res)) {
          resolve(res.list)
        } else {
          reject(Error(res.errorCode))
        }
      })
    })
  },
  userLists(companyId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('bidder/userlists', {id: companyId}).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.lists)
        } else {
          reject(Error(s.errorCode))
        }
      })
    })
  },
  throttleStats(endpointId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('throttle/endpoint', { id: endpointId }).then(stats => {
        if (Dispatcher.success(stats))
          resolve(stats)
        else
          reject(Error(s.errorCode))
      })
    })
  }
}





// WEBPACK FOOTER //
// ./src/demand/api.js